
export const freshchatWidgetInitialize = (props, callback) => {
    console.log("FreshChat Interfae initialized")
    if (window.Freshchat) {
        let room = localStorage.getItem('room')
        let checkedInGuestList = JSON.parse(localStorage.getItem("Check_In_Guest_List"))

        if (room && room != 'null') {
            if (props.freshChatData.login.appId != ""
                && props.freshChatData.login.appKey != ""
                && props.freshChatData.login.domain != "") {

                window.Freshchat.init({
                    appId: props.freshChatData.login.appId,
                    appKey: props.freshChatData.login.appKey,
                    domain: props.freshChatData.login.domain,
                    teamMemberInfoVisible: props.freshChatData.login.teamMemberInfoVisible || false
                }, () => props.setChatWidgetInnitialized(true));


                checkedInGuestList.forEach((guestDetails) => {
                    if(guestDetails.guestToken == props.guestDetail.guestToken){
                        console.log("Updating Freshchat credentials")
                        if(guestDetails.guestProfile.firstName){
                            window.Freshchat.updateUser({
                                "firstName": guestDetails.guestProfile.firstName,
                                "lastName": guestDetails.guestProfile.lastName ? guestDetails.guestProfile.lastName : "",
                                "email": guestDetails.guestProfile.email ? guestDetails.guestProfile.email : ""
                            })
                        } else {
                            window.Freshchat.updateUser({
                                "lastName": guestDetails.guestProfile.lastName ? guestDetails.guestProfile.lastName : "",
                                "email": guestDetails.guestProfile.email ? guestDetails.guestProfile.email : ""
                            })
                        }
                    }
                })

                window.Freshchat.updateUserProperties({
                    "cf_room": room
                })
                console.log('Freshchat sdk initialized for login case')
            }

        } else {
            if (props.freshChatData.logout.appId != ""
                && props.freshChatData.logout.appKey != ""
                && props.freshChatData.logout.domain != "") {

                console.log('Freshchat sdk initialized for logout case')
                window.Freshchat.init({
                    appId: props.freshChatData.logout.appId,
                    appKey: props.freshChatData.logout.appKey,
                    domain: props.freshChatData.logout.domain,
                    teamMemberInfoVisible: props.freshChatData.logout.teamMemberInfoVisible || false
                }, () => props.setChatWidgetInnitialized(true));
            }
        }
        // setState({freshchatInitialized: true})
        callback(true)
    } else {
        callback(true)
        console.log("Freshchat Plugin not found")
    }
}


export const freshchatWidgetShowConversation = () => {
    let room = localStorage.getItem('room');
    
    if(window.Freshchat){
        console.log('show conversation called')
        // window.Freshchat.showConversations();
        if(room && room !== 'null'){
            window.Freshchat.showConversations( {
                tags :["login"],
                filteredViewTitle   : "Tags"
            });
        } else {
            window.Freshchat.showConversations( {
                tags :["logout"],
                filteredViewTitle   : "Tags"
            });
        }
    } else {
        console.log('freshchat plugin not found')
    }
}